import { mainSiteUrl } from '@/mocks/categories';
import { seoContent } from '@/mocks/seo-content';

export default function CTABanner() {
  return (
    <section className="relative bg-secondary-800 py-16 md:py-20 overflow-hidden">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '24px 24px',
        }}></div>
      </div>

      <div className="relative z-10 px-4 md:px-6 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 leading-tight">
          {seoContent.homepageCtaBanner.heading}
        </h2>
        <p className="mt-4 text-sm md:text-base text-background-200/80 leading-relaxed">
          {seoContent.homepageCtaBanner.body}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-semibold hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          Go to Main Platform
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-up-line text-sm"></i>
          </span>
        </a>
      </div>
    </section>
  );
}